<p-dialog [closable]="false" [visible]="loading$ | async" [modal]="false">
    <p-progressSpinner [style]="{ width: '200px', height: '200px' }"></p-progressSpinner>
</p-dialog>
